import classNames from 'classnames';

import type { FC, ReactNode } from 'react';

import styles from './Container.module.scss';

type Props = {
  children?: ReactNode;
  className?: string;
};

const Container: FC<Props> = ({ children, className }) => {
  return (
    <div className={classNames(styles.container, className)}>{children}</div>
  );
};

export { Container };
